import { TabPanel } from 'gf-ui-components-mui-lib';
const ToggleTabs = ({ TabStatus, isSmallScreen, handleType, tabsdata, portal, largeTabs = false }: any) => {
  return (
    <>
      <TabPanel
        variant="standard"
        textColor="primary"
        handleTab={handleType as any}
        sx={{
          '& .MuiTabs-root, .MuiTabs-scroller': {
            overflow: 'visible !important',
          },
          '& .MuiTabs-flexContainer': {
            display: 'flex',
            flexDirection: 'row',
            margin: 0,
            padding: 0,
          },
          '& .MuiToggleButtonGroup-root': {
            padding: '0px',
            margin: '0px',
          },
          '& .MuiBox-root': {
            padding: '0px',
            margin: '0px',
          },

          '& .MuiToggleButton-root': {
            marginTop: '4px',
            textTransform: 'none',
            border: 'none',
            fontSize: isSmallScreen ? '14px' : '16px',
            height: '40px',
            width: isSmallScreen ? '120px' :
              portal ?
                largeTabs
                  ? '220px'
                  : '147px'
                : '140px',
            fontWeight: '400',
            lineHeight: '24px',
            fontFamily: 'Inter',
            borderRadius: '24px',
            background: '#E6EDF5',
            color: '#242424',
            paddingLeft: '33px',
            ':hover': {
              background: '#E6EDF5',
            },
          },
          svg: {
            width: 16,
            height: 16,
            // marginRight: isSmallScreen ? '190px' : '220px',
            // marginTop: '45px'
          },
          '& .Mui-selected.MuiToggleButton-root': {
            backgroundColor: '#3F8CFF !important',
            color: '#fff',
            fontWeight: 700,
            fontFamily: 'Inter',
            // paddingLeft:TabStatus==='Groups'?'30px':'20px',
            // marginLeft:TabStatus==='Users'?'5px':'-5px'
          },
        }}
        {...{
          tabs: tabsdata,
          selectedTab: TabStatus,
          xsm: true,
        }}
      />
    </>
  );
};

export default ToggleTabs;
